import Constants from "./constant";
export default {
    data() {
        // return Constants
        let currentData = {
            options:[],
            optionSearchDriverFarmer:[]
        }
        let newData = {...Constants, ...currentData}
        return newData
    },
    props:{
        isAdmin: {
            type: Boolean,
            default: false
        },
        appOfficesId:null,
        perPageDownload:{
            type: Number,
            default: 1000
        },
        urlSearchDebtUser: {
            type: String,
            default: ""
        },
        urlSearchDriverFarmer: {
            type: String,
            default: ""
        },
    },
    methods: {
        formatNumber(angka) {
            return Math.floor(Number(angka)).toLocaleString('id-ID');
        },
        formatRupiah(angkanya, prefix)
        {
            let nilai = parseFloat(angkanya);
            // let pembulatan = 0;
            // if (!isNaN(nilai)) {
            //     const decimal = nilai % 1;
            //     pembulatan = Math.floor(nilai) + (decimal >= 0.5 ? 1 : 0);
            // }
            // let hasil = pembulatan.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            let hasil = nilai.toString().replace(".", ",");
            hasil = hasil.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            // Tambahkan ,00 jika tidak ada nilai koma
            if (!hasil.includes(',')) {
                hasil += '';
            }
            prefix = prefix ? prefix : "";
            return prefix + hasil;
        },
        formatDate(dateString, originFormat, toFormat)
        {   
            // originFormat = originFormat || "YYYY-MM-DD hh:mm:ss"
            originFormat = originFormat || Constants.dateFormat.ymdhis
            // toFormat = toFormat || "DD/MM/YYYY HH:mm:ss"
            toFormat = toFormat || Constants.dateFormat.DMYHIS_SLASH
            dateString  = dateString || (new Date)
            const momentObjFromString = moment(dateString, originFormat);
            if(momentObjFromString.isValid()){
                return momentObjFromString.format(toFormat)
            }
            const momentObj = moment(dateString);
            if(momentObj.isValid()){
                return momentObj.format(toFormat)
            }
            return null
        },
        getDateFromString(dateString, originFormat, toFormat, toLocalOrUtc)
        {   
            const isToUtc = (toLocalOrUtc || 'local') == 'utc' 

            // originFormat = originFormat || "YYYY-MM-DD hh:mm:ss"
            originFormat = originFormat || Constants.dateFormat.ymdhis
            // toFormat = toFormat || "DD/MM/YYYY HH:mm:ss"
            toFormat = toFormat || Constants.dateFormat.DMYHIS_SLASH
            const isWantMoment = toFormat == 'moment'
            
            const isWantDateReturn = toFormat instanceof Date

            dateString  = dateString || (new Date)
            
            const isFromLocal = dateString instanceof Date // local timezone
            const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const momentObjFromString = isFromLocal ? moment(dateString):moment.utc(dateString, originFormat);

            if(momentObjFromString.isValid()){
                if (isWantDateReturn) {
                    // return momentObjFromString.toDate()
                    return this.momentToLocalOrTimezone(momentObjFromString, isToUtc).toDate()
                } else if (isWantMoment) {
                    return this.momentToLocalOrTimezone(momentObjFromString, isToUtc);
                } else {
                    return this.momentToLocalOrTimezone(momentObjFromString, isToUtc).format(toFormat)
                }
                // return momentObjFromString.format(toFormat)
            }

            const momentObj = moment(dateString);
            if(momentObj.isValid()){
                if (isWantDateReturn) {
                    return this.momentToLocalOrTimezone(momentObj, isToUtc).toDate()
                }else if (isWantMoment) {
                    return this.momentToLocalOrTimezone(momentObj, isToUtc);
                } else {
                    return this.momentToLocalOrTimezone(momentObj, isToUtc).format(toFormat)
                }
            }
            return null
        },
        momentToLocalOrTimezone(momentObj, isToUtc){
            const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (isToUtc) {
                return momentObj.utc()
            }
            return momentObj.tz(localTimeZone)
        },
        getEndOfDayMoment(dateString, isToUtc, toFormat){
            
            let momentObj = '';
            if (dateString instanceof moment) {
                momentObj = dateString
            } else {
                return '';
                
            }
            const endDay = momentObj.endOf('day')
            toFormat = toFormat || Constants.dateFormat.DMYHIS_SLASH

            if (isToUtc) {
                return endDay.format(toFormat)
            }

            return endDay.format(toFormat)
        },
        filterObject(obj, callback) {
            return Object.fromEntries(Object.entries(obj).
              filter(([key, val]) => callback(val, key)));
        },
        fnExcelReport(id_table, callbackGetFileName) {
            id_table = id_table || 'test-print'
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';
        
            tab_text = tab_text + '<x:Name>Test Sheet</x:Name>';
        
            tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
            tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
        
            tab_text = tab_text + "<table border='1px'>";
            tab_text = tab_text + $('#'+id_table).html();
            tab_text = tab_text + '</table></body></html>';
            
            var data_type = 'data:application/vnd.ms-excel';
            
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");
            //$('#test').attr('href', data_type + ', ' + encodeURIComponent(tab_text));
            // window.open(data_type + ', ' + encodeURIComponent(tab_text), 'download-nameeee');
            var link = document.createElement("a");
            link.href =data_type + ', ' + encodeURIComponent(tab_text);
            callbackGetFileName = callbackGetFileName || function () { return 'sample_file_name' }
            const fileName = callbackGetFileName()
            link.download = fileName+".xls";
            link.click();
        
        },
        fnExcelReportBackend(url) {
            var options = {
                params: {
                    per_page: this.pagination.state.per_page,
                    page: this.pagination.state.current_page,
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction,
                    action: 'to-excel'
                }
            };

            Object.assign(options.params, this.filters, this.moduleFilters);
            const validFilter = this.filterObject(options.params, (v, key)=>{ return v !==null})
            const queryString = '?' + new URLSearchParams(validFilter).toString();
            window.open((url || this.url)+queryString,'_blank');
        
        },
        filterObject(obj, callback) {
            return Object.fromEntries(Object.entries(obj).
                filter(([key, val]) => callback(val, key)));
        },
        openUrl(url) {
            var options = {
                params: {
                    per_page: this.pagination.state.per_page,
                    page: this.pagination.state.current_page,
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction,
                }
            };

            Object.assign(options.params, this.filters);
            const queryString = '?' + new URLSearchParams(options.params).toString();
            const urlDefault = this.url+queryString
            const fullUrl = (url || urlDefault)
            // console.log('fullUrl', fullUrl)
            window.open(fullUrl,'_blank');
        
        },
        getListingFileName(prefixName){
            prefixName = prefixName || 'download_file'
            return `${prefixName}_${this.pagination.state.from}_to_${this.pagination.state.to}_of_total_${this.pagination.state.total}_${this.formatDate()}`
        },
        debounce (method, timer) {
            if (this.$_debounceTimer !== null) {
                clearTimeout(this.$_debounceTimer)
            }
            this.$_debounceTimer = setTimeout(() => {
                method()
            }, timer)
        },
        arrayCombine(names, values) {
            var result = {};
            for (var i = 0; i < names.length; i++)
                 result[names[i]] = values[i];
            return result;
        },
        onSubmit: function onSubmit() {
            var _this4 = this;
            _this4.submiting = true;
            return this.$validator.validateAll().then(function (result) {
              if (!result) {
                _this4.$notify({
                  type: 'error',
                  title: 'Error!',
                  text: 'The form contains invalid fields.'
                });
                _this4.submiting = false;
                return false;
              }
      
              var data = _this4.form;
              if (!_this4.sendEmptyLocales) {
                data = _.omit(_this4.form, _this4.locales.filter(function (locale) {
                  return _.isEmpty(_this4.form[locale]);
                }));
              }
      
              _this4.submiting = true;
      
              axios.post(_this4.action, _this4.getPostData()).then(function (response) {
                return _this4.onSuccess(response.data);
              }).catch(function (errors) {
                return _this4.onFail(errors.response.data);
              });
            });
        },
        onSuccess: function onSuccess(data) {
            if (data.redirect) {
              window.location.replace(data.redirect);
            }
        },
        onSearchDebtUser: function onSearchDebtUser(search, loading) {
            if(search.length) {
              loading(true);
              this.searchDebtUser(loading, search, this);
            }
        },
        searchDebtUser: _.debounce((loading, search, vm) => {
            fetch(
            //   `https://api.github.com/search/repositories?q=${escape(search)}`
              `${vm.urlSearchDebtUser}?q=${escape(search)}`
            ).then(res => {
                console.log('res.json()')
                console.log(res)
                // console.log(res.json())
            //   res.json().then(json => (vm.options = json.items));
              res.json().then(function (json) {
                vm.options = json.data
              });
              loading(false);
            });
          }, 350),
        onSearchDriverFarmer: function(search, loading) {
            if(search.length) {
              loading(true);
              this.searchDriverFarmer(loading, search, this);
            }
        },
        searchDriverFarmer: _.debounce((loading, search, vm) => {
            fetch(
              `${vm.urlSearchDriverFarmer}?q=${escape(search)}`
            ).then(res => {
              res.json().then(function (json) {
                console.log('json')
                console.log(json)
                vm.optionSearchDriverFarmer = json.data
              });
              loading(false);
            });
          }, 350)
    }
}

// exports.default = FormMixin;